






import FacturationsEnRetard from "./FacturationsEnRetard.vue";

export default {
    name: "FacturationDashboard",
    components: {
        FacturationsEnRetard,
    },
};
